import {Button, ModalFooter} from '@hm/fundamental'

import type {ImportStep} from '../../hooks'
import {useRiskSurveyTranslation} from '../../hooks'
import type {ImportDuplicateCheckResponseDto as ImportDuplicateCheckResult} from '../../types'

type ImportModalFooterProps = {
  step: ImportStep
  onClose: () => void
  onBack: () => void
  onImport: () => void
  isSubmitting: boolean
  duplicateRiNumbers: string[]
  isCheckingImportDuplicate?: boolean
  duplicateImportCheck?: ImportDuplicateCheckResult | null
  plantInputValid: boolean
  validCount: number
  importResultStatus?: 'success' | 'error' | null
  onImportResultBackToPreview?: () => void
}

export const ImportModalFooter = ({
  step,
  onClose,
  onBack,
  onImport,
  isSubmitting,
  duplicateRiNumbers,
  isCheckingImportDuplicate,
  duplicateImportCheck,
  plantInputValid,
  validCount,
  importResultStatus,
  onImportResultBackToPreview
}: ImportModalFooterProps) => {
  const {t} = useRiskSurveyTranslation()

  return (
    <ModalFooter>
      <Button variant="tertiary" onClick={onClose} data-cy="import-cancel-button">
        {t('common.cancel')}
      </Button>

      {step === 'preview' && (
        <>
          <Button variant="tertiary" onClick={onBack} data-cy="import-back-button">
            {t('common.back')}
          </Button>
          <Button
            onClick={onImport}
            disabled={
              validCount === 0 ||
              isSubmitting ||
              duplicateRiNumbers.length > 0 ||
              isCheckingImportDuplicate ||
              duplicateImportCheck?.isExactDuplicate ||
              !plantInputValid
            }
            data-cy="import-confirm-button"
          >
            {t('import.confirm')}
          </Button>
        </>
      )}

      {step === 'submitting' && importResultStatus === 'error' && (
        <Button
          variant="tertiary"
          onClick={onImportResultBackToPreview}
          data-cy="import-back-to-preview-button"
        >
          {t('common.back')}
        </Button>
      )}

      {step === 'submitting' && importResultStatus === 'success' && (
        <Button onClick={onClose} data-cy="import-close-success-button">
          {t('common.confirm')}
        </Button>
      )}
    </ModalFooter>
  )
}
